module.exports = __webpack_public_path__ + "static/media/logo2.e312bf06.png";